export default "__VITE_ASSET__CWVpgqbe__"